/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface TierModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class TierApiService extends SignalAdminResourceApiBase<TierModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'tiers');
  }

  listAll(): Observable<SignalAdminResourcePage<TierModel>> {
    return this.client.request<SignalAdminResourcePage<TierModel>>({
      method: 'GET',
      url: this.resourceUri('tiers'),
      params: {
        includeActive: true,
        includeInactive: false,
        includeHidden: false,
        orderBy: 'name',
        pageSize: 1001
      }
    });
  }
}
